var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: {
        title: _vm.titleDialog,
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "600px",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onHandleClose,
      },
    },
    [
      _c("div", { staticClass: "contents contents-cnt" }, [
        _vm.formData.tag_list.length
          ? _c(
              "div",
              { staticClass: "tag-list" },
              _vm._l(_vm.formData.tag_list, function (child, index) {
                return _c("div", { key: index, staticClass: "tag" }, [
                  _c(
                    "div",
                    { staticClass: "name" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "",
                          clearable: "",
                          maxlength: "10",
                        },
                        model: {
                          value: child.name,
                          callback: function ($$v) {
                            _vm.$set(child, "name", $$v)
                          },
                          expression: "child.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "icon-wrap",
                      on: {
                        click: function ($event) {
                          return _vm.onDelete(index)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon el-icon-delete" })]
                  ),
                  _c("div", { staticClass: "icon-wrap" }, [
                    index === _vm.formData.tag_list.length - 1 &&
                    _vm.formData.tag_list.length < _vm.MAX_TAG_LENGTH
                      ? _c("i", {
                          staticClass: "icon el-icon-plus",
                          on: { click: _vm.onCreate },
                        })
                      : _vm._e(),
                  ]),
                ])
              }),
              0
            )
          : _c("div", { staticClass: "tag-add", on: { click: _vm.onCreate } }, [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(" 添加标签 "),
            ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onHandleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loadingSubmit },
              on: { click: _vm.onHandleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }